import { ComponentProps, MutableRefObject } from "react";

type EditTaskProps = {
  titleInputRef: MutableRefObject<any>;
} & ComponentProps<"form">;

export function EditTask({ onSubmit, titleInputRef }: EditTaskProps) {
  return (
    <>
      <input type="checkbox" id="editModal" className="modal-toggle" />
      <div className="modal">
        <div className="modal-box">
          <form onSubmit={onSubmit}>
            <p className="font-bold text-lg">عنوان جدید را وارد کنید</p>
            <input
              type="text"
              className="input w-full max-w-xs input-bordered mt-5"
              name="title"
              required
              ref={titleInputRef}
            />

            <div className="modal-action">
              <div className="flex w-full justify-between mt-10">
                <label
                  htmlFor="editModal"
                  className="btn btn-outline btn-error"
                >
                  بستن
                </label>
                <button className="btn btn-info px-10" type="submit">
                  بله
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </>
  );
}
